export default "<show-story\n[isGuest]='true'></show-story>"